import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {GasData} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-edit-gas',
    templateUrl: './edit-gas.component.html',
    styleUrls: ['./edit-gas.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditGasComponent {
  @Input() gas: GasData;
}
